import React, { useState } from "react";
import { Button, Icon, Confirm, Popup } from "semantic-ui-react";
import { BasicModal } from "../../../Shared";
import { Document } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { DocumentForm } from "../DocumentForm";
import "./DocumentItem.scss";

const documentController = new Document();

export function DocumentItem(props) {
  const { document, onReload } = props;
  const { accessToken } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateGrade = () => {
    setTitleModal(`Actualizar documento: ${document.name}`);
    onOpenCloseModal();
  };

  const openDeleteConfirm = () => {
    setConfirmMessage(`¿Eliminar el documento ${document.name}?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await documentController.deleteDocument(accessToken, document.id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="document-item">
        <div className="document-item__info">
          <span className="document-item__info-name">{document.name}</span>
        </div>
        <div>
          <Popup
            content="Actualizar documento"
            trigger={
              <Button icon primary onClick={openUpdateGrade}>
                <Icon name="pencil" />
              </Button>
            }
          />
          <Popup
            content="Eliminar documento"
            trigger={
              <Button icon color="red" onClick={openDeleteConfirm}>
                <Icon name="trash" />
              </Button>
            }
          />
        </div>
      </div>
      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal}>
        <DocumentForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          document={document}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={onDelete}
        content={confirmMessage}
        size="mini"
      />
    </>
  );
}
